// Comprehensive mock dataset for Sangeetha Customer Care UI

export const branchOfficeMaster = [
    {
        branchCode: 'KOR-001',
        storeCode: 'KOR',
        branchName: 'Koramangala 8th Block',
        city: 'Bengaluru',
        manager: 'Ravi Kumar',
        phone: '+91 98450 12345',
        email: 'koramangala.manager@sangeethamobiles.com',
        address: 'No. 432, 80 Feet Road, Koramangala 8th Block, Bengaluru, Karnataka 560095',
        asm: 'Ravikumar C N-6530',
        salesHead: 'Santhosh B-6224',
        businessHead: 'Subhash Chandra-6110',
        bomCount: 128,
        status: 'Active',
        bomItems: [
            { id: 1, modelName: 'Galaxy A54', sku: 'SKU-1001', quantity: 24, status: 'In Stock' },
            { id: 2, modelName: 'iPhone 14', sku: 'SKU-1002', quantity: 12, status: 'In Stock' },
            { id: 3, modelName: 'Redmi Note 13', sku: 'SKU-1003', quantity: 45, status: 'In Stock' },
            { id: 4, modelName: 'OnePlus Nord CE3', sku: 'SKU-1004', quantity: 32, status: 'In Stock' },
            { id: 5, modelName: 'Vivo V29', sku: 'SKU-1005', quantity: 15, status: 'Low Stock' },
        ]
    },
    {
        branchCode: 'IND-002',
        storeCode: 'IND',
        branchName: 'Indiranagar Metro Station',
        city: 'Bengaluru',
        manager: 'Meera Sharma',
        phone: '+91 98450 67890',
        email: 'indiranagar.manager@sangeethamobiles.com',
        address: 'Metro Pillar 130, 100 Feet Rd, Indiranagar, Bengaluru, Karnataka 560038',
        asm: 'Ravikumar C N-6530',
        salesHead: 'Santhosh B-6224',
        businessHead: 'Subhash Chandra-6110',
        bomCount: 104,
        status: 'Active',
        bomItems: [
            { id: 1, modelName: 'Galaxy A54', sku: 'SKU-1001', quantity: 16, status: 'In Stock' },
            { id: 2, modelName: 'Redmi Note 13', sku: 'SKU-1003', quantity: 31, status: 'In Stock' },
            { id: 3, modelName: 'OnePlus Nord CE3', sku: 'SKU-1004', quantity: 8, status: 'Low Stock' },
            { id: 4, modelName: 'Vivo V29', sku: 'SKU-1005', quantity: 49, status: 'In Stock' },
        ]
    },
    {
        branchCode: 'WHF-003',
        storeCode: 'WHF',
        branchName: 'Whitefield ITPL Road',
        city: 'Bengaluru',
        manager: 'Arun Nair',
        phone: '+91 98450 54321',
        email: 'whitefield.manager@sangeethamobiles.com',
        address: 'Ground Floor, Sigma Soft Tech Park, ITPL Road, Whitefield, Bengaluru, Karnataka 560066',
        asm: 'Ravikumar C N-6530',
        salesHead: 'Santhosh B-6224',
        businessHead: 'Subhash Chandra-6110',
        bomCount: 96,
        status: 'Active',
        bomItems: [
            { id: 1, modelName: 'iPhone 14', sku: 'SKU-1002', quantity: 7, status: 'Low Stock' },
            { id: 2, modelName: 'OnePlus Nord CE3', sku: 'SKU-1004', quantity: 14, status: 'In Stock' },
            { id: 3, modelName: 'Vivo V29', sku: 'SKU-1005', quantity: 0, status: 'Out of Stock' },
            { id: 4, modelName: 'Galaxy A54', sku: 'SKU-1001', quantity: 75, status: 'In Stock' },
        ]
    },
    {
        branchCode: 'JAY-004',
        storeCode: 'JAY',
        branchName: 'Jayanagar 4th Block',
        city: 'Bengaluru',
        manager: 'Srinivas Murthy',
        phone: '+91 98450 99887',
        email: 'jayanagar.manager@sangeethamobiles.com',
        address: 'No. 12, 11th Main Road, Jayanagar 4th Block, Bengaluru, Karnataka 560011',
        asm: 'Ravikumar C N-6530',
        salesHead: 'Santhosh B-6224',
        businessHead: 'Subhash Chandra-6110',
        bomCount: 142,
        status: 'Active',
        bomItems: [
            { id: 1, modelName: 'Galaxy A54', sku: 'SKU-1001', quantity: 35, status: 'In Stock' },
            { id: 2, modelName: 'iPhone 14', sku: 'SKU-1002', quantity: 18, status: 'In Stock' },
            { id: 3, modelName: 'Redmi Note 13', sku: 'SKU-1003', quantity: 50, status: 'In Stock' },
            { id: 4, modelName: 'OnePlus Nord CE3', sku: 'SKU-1004', quantity: 22, status: 'In Stock' },
            { id: 5, modelName: 'Vivo V29', sku: 'SKU-1005', quantity: 17, status: 'In Stock' },
        ]
    },
    {
        branchCode: 'MAL-005',
        storeCode: 'MAL',
        branchName: 'Malleshwaram 15th Cross',
        city: 'Bengaluru',
        manager: 'Anitha Rao',
        phone: '+91 98450 33445',
        email: 'malleshwaram.manager@sangeethamobiles.com',
        address: 'No. 88, Sampige Road, Malleshwaram, Bengaluru, Karnataka 560003',
        asm: 'Ravikumar C N-6530',
        salesHead: 'Santhosh B-6224',
        businessHead: 'Subhash Chandra-6110',
        bomCount: 88,
        status: 'Active',
        bomItems: [
            { id: 1, modelName: 'Galaxy A54', sku: 'SKU-1001', quantity: 9, status: 'Low Stock' },
            { id: 2, modelName: 'iPhone 14', sku: 'SKU-1002', quantity: 5, status: 'Low Stock' },
            { id: 3, modelName: 'Redmi Note 13', sku: 'SKU-1003', quantity: 28, status: 'In Stock' },
            { id: 4, modelName: 'OnePlus Nord CE3', sku: 'SKU-1004', quantity: 0, status: 'Out of Stock' },
            { id: 5, modelName: 'Vivo V29', sku: 'SKU-1005', quantity: 46, status: 'In Stock' },
        ]
    }
];

export const itemModelMaster = [
    {
        sku: 'SKU-1001',
        modelName: 'Galaxy A54',
        brand: 'Samsung',
        category: 'Smartphone',
        mrp: 34999,
        status: 'Active',
        specs: {
            display: '6.4-inch Super AMOLED 120Hz',
            processor: 'Exynos 1380',
            ram: '8 GB',
            storage: '256 GB',
            battery: '5000 mAh',
            camera: '50MP (OIS) + 12MP + 5MP Rear, 32MP Front'
        },
        description: ''
    },
    {
        sku: 'SKU-1002',
        modelName: 'iPhone 14',
        brand: 'Apple',
        category: 'Smartphone',
        mrp: 69999,
        status: 'Active',
        specs: {
            display: '6.1-inch Super Retina XDR OLED',
            processor: 'Apple A15 Bionic',
            ram: '6 GB',
            storage: '128 GB',
            battery: '3279 mAh',
            camera: '12MP + 12MP Rear, 12MP Front'
        },
        description: 'Top-tier Apple smartphone featuring crash detection, incredible low-light photography, and industry-leading performance.'
    },
    {
        sku: 'SKU-1003',
        modelName: 'Redmi Note 13',
        brand: 'Xiaomi',
        category: 'Smartphone',
        mrp: 18999,
        status: 'Active',
        specs: {
            display: '6.67-inch AMOLED 120Hz',
            processor: 'MediaTek Dimensity 6080',
            ram: '6 GB',
            storage: '128 GB',
            battery: '5000 mAh',
            camera: '108MP + 8MP + 2MP Rear, 16MP Front'
        },
        description: 'Budget-friendly 5G device offering a sharp 108MP camera, vibrant display, and exceptionally long battery life.'
    },
    {
        sku: 'SKU-1004',
        modelName: 'OnePlus Nord CE3',
        brand: 'OnePlus',
        category: 'Smartphone',
        mrp: 26999,
        status: 'Active',
        specs: {
            display: '6.7-inch Fluid AMOLED 120Hz',
            processor: 'Snapdragon 782G',
            ram: '8 GB',
            storage: '128 GB',
            battery: '5000 mAh',
            camera: '50MP + 8MP + 2MP Rear, 16MP Front'
        },
        description: 'The community favorite featuring 80W SuperVOOC fast charging, clean OxygenOS, and smooth performance.'
    },
    {
        sku: 'SKU-1005',
        modelName: 'Vivo V29',
        brand: 'Vivo',
        category: 'Smartphone',
        mrp: 32999,
        status: 'Active',
        specs: {
            display: '6.78-inch 3D Curved AMOLED',
            processor: 'Snapdragon 778G',
            ram: '8 GB',
            storage: '256 GB',
            battery: '4600 mAh',
            camera: '50MP (OIS) + 8MP + 2MP Rear with Smart Aura Light, 50MP Front'
        },
        description: 'Slim curved smartphone designed for portrait photography enthusiasts with intelligent aura ring-light.'
    }
];

export const stockByBranch = [
    { branchCode: 'KOR-001', branchName: 'Koramangala 8th Block', sku: 'SKU-1001', modelName: 'Galaxy A54', quantity: 24 },
    { branchCode: 'KOR-001', branchName: 'Koramangala 8th Block', sku: 'SKU-1002', modelName: 'iPhone 14', quantity: 12 },
    { branchCode: 'KOR-001', branchName: 'Koramangala 8th Block', sku: 'SKU-1003', modelName: 'Redmi Note 13', quantity: 45 },
    { branchCode: 'KOR-001', branchName: 'Koramangala 8th Block', sku: 'SKU-1004', modelName: 'OnePlus Nord CE3', quantity: 32 },
    { branchCode: 'KOR-001', branchName: 'Koramangala 8th Block', sku: 'SKU-1005', modelName: 'Vivo V29', quantity: 15 },

    { branchCode: 'IND-002', branchName: 'Indiranagar Metro Station', sku: 'SKU-1001', modelName: 'Galaxy A54', quantity: 16 },
    { branchCode: 'IND-002', branchName: 'Indiranagar Metro Station', sku: 'SKU-1003', modelName: 'Redmi Note 13', quantity: 31 },
    { branchCode: 'IND-002', branchName: 'Indiranagar Metro Station', sku: 'SKU-1004', modelName: 'OnePlus Nord CE3', quantity: 8 },
    { branchCode: 'IND-002', branchName: 'Indiranagar Metro Station', sku: 'SKU-1005', modelName: 'Vivo V29', quantity: 49 },

    { branchCode: 'WHF-003', branchName: 'Whitefield ITPL Road', sku: 'SKU-1002', modelName: 'iPhone 14', quantity: 7 },
    { branchCode: 'WHF-003', branchName: 'Whitefield ITPL Road', sku: 'SKU-1004', modelName: 'OnePlus Nord CE3', quantity: 14 },
    { branchCode: 'WHF-003', branchName: 'Whitefield ITPL Road', sku: 'SKU-1005', modelName: 'Vivo V29', quantity: 0 },
    { branchCode: 'WHF-003', branchName: 'Whitefield ITPL Road', sku: 'SKU-1001', modelName: 'Galaxy A54', quantity: 75 },

    { branchCode: 'JAY-004', branchName: 'Jayanagar 4th Block', sku: 'SKU-1001', modelName: 'Galaxy A54', quantity: 35 },
    { branchCode: 'JAY-004', branchName: 'Jayanagar 4th Block', sku: 'SKU-1002', modelName: 'iPhone 14', quantity: 18 },
    { branchCode: 'JAY-004', branchName: 'Jayanagar 4th Block', sku: 'SKU-1003', modelName: 'Redmi Note 13', quantity: 50 },
    { branchCode: 'JAY-004', branchName: 'Jayanagar 4th Block', sku: 'SKU-1004', modelName: 'OnePlus Nord CE3', quantity: 22 },
    { branchCode: 'JAY-004', branchName: 'Jayanagar 4th Block', sku: 'SKU-1005', modelName: 'Vivo V29', quantity: 17 },

    { branchCode: 'MAL-005', branchName: 'Malleshwaram 15th Cross', sku: 'SKU-1001', modelName: 'Galaxy A54', quantity: 9 },
    { branchCode: 'MAL-005', branchName: 'Malleshwaram 15th Cross', sku: 'SKU-1002', modelName: 'iPhone 14', quantity: 5 },
    { branchCode: 'MAL-005', branchName: 'Malleshwaram 15th Cross', sku: 'SKU-1003', modelName: 'Redmi Note 13', quantity: 28 },
    { branchCode: 'MAL-005', branchName: 'Malleshwaram 15th Cross', sku: 'SKU-1004', modelName: 'OnePlus Nord CE3', quantity: 0 },
    { branchCode: 'MAL-005', branchName: 'Malleshwaram 15th Cross', sku: 'SKU-1005', modelName: 'Vivo V29', quantity: 46 }
];

export const salesInvoiceList = [
    {
        invoiceNo: 'INV-2026-001',
        branchName: 'Koramangala 8th Block',
        branchCode: 'KOR-001',
        customerName: 'Rahul Kumar',
        customerPhone: '+91 99887 76655',
        customerEmail: 'rahul.kumar@gmail.com',
        amount: 34999,
        taxAmount: 5338, // 18% GST included
        subtotal: 29661,
        invoiceDate: '2026-06-18',
        paymentMode: 'UPI / GPay',
        status: 'Paid',
        imei: '358240051111111',
        items: [
            { sku: 'SKU-1001', modelName: 'Galaxy A54', brand: 'Samsung', category: 'Smartphone', quantity: 1, price: 34999, total: 34999 }
        ]
    },
    {
        invoiceNo: 'INV-2026-002',
        branchName: 'Indiranagar Metro Station',
        branchCode: 'IND-002',
        customerName: 'Asha Menon',
        customerPhone: '+91 98765 43210',
        customerEmail: 'asha.menon@outlook.com',
        amount: 88998,
        taxAmount: 13576,
        subtotal: 75422,
        invoiceDate: '2026-06-19',
        paymentMode: 'Credit Card (HDFC)',
        status: 'Paid',
        imei: '358240052222222, 358240053333333',
        items: [
            { sku: 'SKU-1002', modelName: 'iPhone 14', brand: 'Apple', category: 'Smartphone', quantity: 1, price: 69999, total: 69999 },
            { sku: 'SKU-1003', modelName: 'Redmi Note 13', brand: 'Xiaomi', category: 'Smartphone', quantity: 1, price: 18999, total: 18999 }
        ]
    },
    {
        invoiceNo: 'INV-2026-003',
        branchName: 'Whitefield ITPL Road',
        branchCode: 'WHF-003',
        customerName: 'Vikram Aditya',
        customerPhone: '+91 90001 20002',
        customerEmail: 'vikram.aditya@techcorp.com',
        amount: 53998,
        taxAmount: 8237,
        subtotal: 45761,
        invoiceDate: '2026-06-25',
        paymentMode: 'Net Banking',
        status: 'Paid',
        imei: '358240054444444',
        items: [
            { sku: 'SKU-1004', modelName: 'OnePlus Nord CE3', brand: 'OnePlus', category: 'Smartphone', quantity: 2, price: 26999, total: 53998 }
        ]
    },
    {
        invoiceNo: 'INV-2026-004',
        branchName: 'Jayanagar 4th Block',
        branchCode: 'JAY-004',
        customerName: 'Priya Narayanan',
        customerPhone: '+91 91122 33445',
        customerEmail: 'priya.n@yahoo.com',
        amount: 32999,
        taxAmount: 5034,
        subtotal: 27965,
        invoiceDate: '2026-06-28',
        paymentMode: 'Cash',
        status: 'Paid',
        imei: '358240055555555',
        items: [
            { sku: 'SKU-1005', modelName: 'Vivo V29', brand: 'Vivo', category: 'Smartphone', quantity: 1, price: 32999, total: 32999 }
        ]
    }
];

export const imeiHistory = {
    '358240051111111': {
        imei: '358240051111111',
        modelName: 'Galaxy A54',
        brand: 'Samsung',
        sku: 'SKU-1001',
        warrantyStatus: 'Under Warranty (Ends 2027-06-20)',
        currentStatus: 'Activated',
        customerName: 'Rahul Kumar',
        history: [
            { status: 'Received', date: '2026-06-01 10:00', branchName: 'Central Warehouse (WH-001)', notes: 'Inwarded from manufacturing supplier' },
            { status: 'Transferred', date: '2026-06-10 14:30', branchName: 'Koramangala 8th Block', notes: 'Dispatched via logistics batch #LG-992' },
            { status: 'Sold & Invoiced', date: '2026-06-18 16:15', branchName: 'Koramangala 8th Block', notes: 'Sold to Rahul Kumar (Invoice No: INV-2026-001)' },
            { status: 'Activated', date: '2026-06-20 10:30', branchName: 'Koramangala 8th Block', notes: 'Device activated and registered on Samsung servers' }
        ]
    },
    '358240052222222': {
        imei: '358240052222222',
        modelName: 'iPhone 14',
        brand: 'Apple',
        sku: 'SKU-1002',
        warrantyStatus: 'Under Warranty (Ends 2027-06-19)',
        currentStatus: 'Transferred',
        customerName: 'Asha Menon',
        history: [
            { status: 'Received', date: '2026-06-02 11:15', branchName: 'Central Warehouse (WH-001)', notes: 'Inwarded under batch #AP-881' },
            { status: 'Transferred', date: '2026-06-12 12:00', branchName: 'Whitefield ITPL Road', notes: 'Stock distribution transit' },
            { status: 'Transferred', date: '2026-06-17 14:10', branchName: 'Indiranagar Metro Station', notes: 'Inter-branch stock transfer authorized by ASM' },
            { status: 'Sold & Invoiced', date: '2026-06-19 11:45', branchName: 'Indiranagar Metro Station', notes: 'Sold to Asha Menon (Invoice No: INV-2026-002)' }
        ]
    },
    '358240053333333': {
        imei: '358240053333333',
        modelName: 'Redmi Note 13',
        brand: 'Xiaomi',
        sku: 'SKU-1003',
        warrantyStatus: 'Under Warranty (Ends 2027-06-19)',
        currentStatus: 'Under Service',
        customerName: 'Asha Menon',
        history: [
            { status: 'Received', date: '2026-06-03 09:30', branchName: 'Central Warehouse (WH-001)', notes: 'Inwarded under batch #XI-441' },
            { status: 'Transferred', date: '2026-06-14 10:20', branchName: 'Indiranagar Metro Station', notes: 'Stock distribution transit' },
            { status: 'Sold & Invoiced', date: '2026-06-19 11:45', branchName: 'Indiranagar Metro Station', notes: 'Sold to Asha Menon (Invoice No: INV-2026-002)' },
            { status: 'Service Inward', date: '2026-06-22 16:45', branchName: 'Whitefield Support Center', notes: 'Awaiting customer verification. Issue reported: Display flickering' }
        ]
    }
};
